/**
 * The stages of a transcript order's lifecycle. The status is computed using the order status and the job status.
 */
export var TranscriptOrderStatus;
(function (TranscriptOrderStatus) {
    /**
     * Order is awaiting payment of the estimate amount.
     * Orders with this status are hidden in the transcript orders list.
     * @see OrderStatus.AwaitingEstimateAuthorization
     */
    TranscriptOrderStatus["AwaitingEstimateAuthorization"] = "awaiting estimate authorization";
    /**
     * Order is awaiting approval by a clerk that the order can be serviced.
     * @deprecated The new transcript order pages use {@link AwaitingAssignment} instead.
     * @see OrderStatus.AwaitingApproval
     */
    TranscriptOrderStatus["AwaitingApproval"] = "awaiting approval";
    /**
     * Order is awaiting more information from the customer.
     * @deprecated The new transcript order pages use {@link MoreInformationNeeded} instead.
     * @see OrderStatus.AwaitingMoreInformation
     */
    TranscriptOrderStatus["AwaitingMoreInformation"] = "awaiting more information";
    /**
     * Order is awaiting more information from the customer.
     * @see OrderStatus.AwaitingMoreInformation
     */
    TranscriptOrderStatus["MoreInformationNeeded"] = "more information needed";
    /**
     * Job is awaiting assignment to a transcriber.
     * @see OrderStatus.AwaitingApproval
     * @see OrderStatus.InProgress
     * @see JobStatus.Pending
     */
    TranscriptOrderStatus["AwaitingAssignment"] = "awaiting assignment";
    /**
     * Order is currently being fulfilled.
     * @see OrderStatus.InProgress
     * @see JobStatus.Assigned
     */
    TranscriptOrderStatus["InProgress"] = "in progress";
    /**
     * To be implemented with the new transcript order review workflow.
     */
    TranscriptOrderStatus["InReview"] = "in review";
    /**
     * Transcript has been submitted for review and order is awaiting fulfillment.
     * @deprecated The new transcript order pages use {@link AwaitingFulfillment} instead.
     * @see OrderStatus.InProgress
     * @see JobStatus.InReview
     */
    TranscriptOrderStatus["AwaitingTranscriptConfirmation"] = "awaiting transcript confirmation";
    /**
     * Transcript has been submitted for review and order is awaiting fulfillment.
     * @see OrderStatus.InProgress
     * @see JobStatus.InReview
     */
    TranscriptOrderStatus["AwaitingFulfillment"] = "awaiting fulfillment";
    /**
     * Order is awaiting settlement of the estimate payment authorization.
     * Orders with this status are hidden in the transcript orders list.
     * @see OrderStatus.AwaitingEstimateSettlement
     */
    TranscriptOrderStatus["AwaitingEstimateSettlement"] = "awaiting estimate settlement";
    /**
     * Order is awaiting payment of the balance amount (i.e. the difference between the final amount and the estimate).
     * @deprecated The new transcript order pages use {@link PaymentOwing} instead.
     * @see OrderStatus.AwaitingBalancePayment
     */
    TranscriptOrderStatus["AwaitingBalancePayment"] = "awaiting balance payment";
    /**
     * Order is awaiting payment of the balance amount (i.e. the difference between the final amount and the estimate).
     * @see OrderStatus.AwaitingBalancePayment
     */
    TranscriptOrderStatus["PaymentOwing"] = "payment owing";
    /**
     * Order has been completed and the product delivered to the customer.
     * @see OrderStatus.Completed
     */
    TranscriptOrderStatus["Completed"] = "completed";
    /**
     * Order has been canceled prior to completion.
     * @see OrderStatus.Canceled
     */
    TranscriptOrderStatus["Canceled"] = "canceled";
    /**
     * Order and job are in unexpected state.
     * @see OrderStatus.InProgress
     * @see JobStatus.Completed
     * @see JobStatus.Canceled
     */
    TranscriptOrderStatus["Error"] = "error";
})(TranscriptOrderStatus || (TranscriptOrderStatus = {}));
